import AddDepartment from "../../../../components/company/organization/department/AddDepartment";

const AddDepartmentPage = () => {
    return <AddDepartment />
}

export default AddDepartmentPage;